module.exports = __webpack_public_path__ + "public/images/schedule/networking-day.4995bc5ae9ae60929618abc4809e062e.svg";